import { ControlGroup } from "@blueprintjs/core";
import { default as Autobind } from "autobind-decorator";
import React from "react";

import IOption from "common/models/IOption";
import { iDefL } from "core/util/TypeUtils";
import BaseWidget from "./BaseWidget";
import ButtonSelect from "./common/ButtonSelect";
import LinearGradientWidget from "./LinearGradientWidget";
import TextWidget from "./TextWidget";

interface IBackgroundImage {
	type: string;
	value: string;
}

const options: IOption[] = [
	{ value: "url", label: "Image", icon: "camera" },
	{ value: "linear-gradient", label: "Gradient", icon: "tint" }
];

export default class BackgroundImageWidget extends BaseWidget<IBackgroundImage, string> {

	public render() {
		const backgroundImage = this.fromValue(this.props.value);

		return (
			<ControlGroup fill={true} vertical={true}>
				<ButtonSelect
					options={options}
					onChange={(value) => this.onChange(backgroundImage, value, "type")}
					value={backgroundImage.type}
					autofocus={false}
					readonly={false}
				/>
				{
					backgroundImage.type === "url" ? (
						<TextWidget
							autofocus={false}
							readonly={false}
							onChange={(value) => this.onChange(backgroundImage, value, "value")}
							options={undefined}
							value={backgroundImage.value}
						/>
					) : backgroundImage.type === "linear-gradient" ? (
						<LinearGradientWidget
							autofocus={false}
							readonly={false}
							onChange={(value) => this.onChange(backgroundImage, value, "value")}
							options={undefined}
							value={backgroundImage.value}
						/>
					) : null
				}
			</ControlGroup>
		);
	}

	@Autobind
	public onChange(backgroundImage: IBackgroundImage, value: string, part: string) {
		if (part === "type") {
			this.props.onChange(this.toValue({
				type: value,
				value: ""
			}));
		} else {
			this.props.onChange(this.toValue({...backgroundImage, [part]: value}));
		}
	}

	@Autobind
	protected toValue(backgroundImage: IBackgroundImage): string {
		const { type, value } = backgroundImage;
		return `${type}(${value})`;
	}

	@Autobind
	protected fromValue(val: string): IBackgroundImage {
		if (!iDefL(val)) {
			return {
				type: "url",
				value: ""
			};
		}

		// not 100% sure if this is a good idea.
		const type: string = val.match(/(url|linear\-gradient)/)[0] || "url";
		const value: string = val.indexOf("(") + 1 < val.length ?
			val.slice(val.indexOf("(") + 1, val.length - 1) : "";

		return { type, value };
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/BackgroundImageWidget.tsx